<template>
<ItpModal
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CompanyDataImportModal"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <DIV
      class="container"
    >
      <ItpForm
        name="clientDataImport"
        ref="form"
        v-if="loaded"
        @submit="evh_5534025912102772_submit($event, {})"
      >
        <ItpFormGroup
          row
          name="file"
          :label="'File'|gettext"
          labelFor="file"
          label-cols-md="2"
          content-cols-md="10"
        >
          <ItpFormFile
            v-model="file"
            name="file"
            size="md"
            accept=".xlsx, .csv"
            required
          >
          </ItpFormFile>
        </ItpFormGroup>
        <ItpFormGroup
          row
          name="header"
          label-cols-md="0"
          content-cols-md="12"
        >
          <ItpFormCheckbox
            name="headered"
            :label="'Import file has header'|gettext"
            v-model="headered"
            size="md"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <ItpFormGroup
          row
          name="colnum_number"
          :label="'Number column number'|gettext"
          label-cols-md="5"
          content-cols-md="3"
        >
          <ItpFormInput
            type="number"
            name="colnum_number"
            v-model="colnum_number"
            size="md"
            number
            required
            min="1"
          >
          </ItpFormInput>
        </ItpFormGroup>
        <ItpFormGroup
          row
          name="colnum_name"
          :label="'Name column number'|gettext"
          label-cols-md="5"
          content-cols-md="3"
        >
          <ItpFormInput
            type="number"
            name="colnum_name"
            v-model="colnum_name"
            size="md"
            number
            required
            min="1"
          >
          </ItpFormInput>
        </ItpFormGroup>
        <ItpFormGroup
          row
          name="colnum_email"
          :label="'Email column number'|gettext"
          label-cols-md="5"
          content-cols-md="3"
        >
          <ItpFormInput
            type="number"
            name="colnum_email"
            v-model="colnum_email"
            size="md"
            number
            required
            min="1"
          >
          </ItpFormInput>
        </ItpFormGroup>
      </ItpForm>
    </DIV>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="forms.clientDataImport && forms.clientDataImport.id"
      :text="'Import'|gettext"
      type="submit"
      variant="primary"
      icon="fa-file-import"
      :spinning="actions.submit.isRunning"
      :disabled="!forms.clientDataImport || !forms.clientDataImport.submittable"
    >
    </ItpButton>
    <ItpButton
      :text="'Cancel'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpModal>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CompanyDataImportModal extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "modal",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  file!: any;
  headered!: any;
  colnum_number!: any;
  colnum_name!: any;
  colnum_email!: any;
  ux!: any;
  dataMembers = ['file', 'headered', 'colnum_number', 'colnum_name', 'colnum_email', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        file: null,
        headered: true,
        colnum_number: 1,
        colnum_name: 2,
        colnum_email: 3,
        ux: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.gettext("Import client data"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3626_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3626, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_5534025912102772_register_3632_getActionArgs($event: actions.ActionEvent): Promise<actions.RegisterActionArgs> {
    // parameterResolver name=act_5534025912102772_register_3632, alias=undefined
    return {
      name: "resultLength",
      value: $event.data.response.data ? $event.data.response.data.updated_records : 0,
    }
  }

  async act_5534025912102772_notification_3634_getActionArgs($event: actions.ActionEvent): Promise<actions.NotificationActionArgs> {
    // parameterResolver name=act_5534025912102772_notification_3634, alias=undefined
    return {
      message: this.$fn.ngettext("One record imported.", "${n} records imported.", $event.data.resultLength),
    }
  }

  async act_5534025912102772_notification_3634_getWhen($event: actions.ActionEvent): Promise<actions.NotificationActionArgs> {
    // parameterResolver name=act_5534025912102772_notification_3634, alias=undefined
    return $event.data.resultLength > 0
  }

  async act_5534025912102772_notification_3636_getActionArgs($event: actions.ActionEvent): Promise<actions.NotificationActionArgs> {
    // parameterResolver name=act_5534025912102772_notification_3636, alias=undefined
    return {
      message: this.$fn.gettext("Nothing has been imported."),
    }
  }

  async act_5534025912102772_notification_3636_getWhen($event: actions.ActionEvent): Promise<actions.NotificationActionArgs> {
    // parameterResolver name=act_5534025912102772_notification_3636, alias=undefined
    return !$event.data.resultLength
  }

  async act_5534025912102772_closeModal_3638_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_5534025912102772_closeModal_3638, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_5534025912102772_reloadSlickgrid_3640_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_5534025912102772_reloadSlickgrid_3640, alias=undefined
    return {
      grid: "all",
    }
  }

  async act_5534025912102772_request_3630_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_5534025912102772_request_3630, alias=submit
    return {
      operation: "import_clients",
      data: { header: this.headered, file: this.file, colnum_number: this.colnum_number, colnum_name: this.colnum_name, colnum_email: this.colnum_email },
    }
  }

  async evh_5534025912102772_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_3642_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_3642, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3626: actions.CloseModalAction;
    evh_7315092382398562_close_3625: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_3628: actions.CloseComponentAction;
    evh_2248226175642056_close_3627: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_5534025912102772_register_3632: actions.RegisterAction;
    evh_5534025912102772_success_3631: actions.EventHandlerImpl;
    act_5534025912102772_notification_3634: actions.NotificationAction;
    evh_5534025912102772_success_3633: actions.EventHandlerImpl;
    act_5534025912102772_notification_3636: actions.NotificationAction;
    evh_5534025912102772_success_3635: actions.EventHandlerImpl;
    act_5534025912102772_closeModal_3638: actions.CloseModalAction;
    evh_5534025912102772_success_3637: actions.EventHandlerImpl;
    act_5534025912102772_reloadSlickgrid_3640: actions.ReloadSlickgridAction;
    evh_5534025912102772_success_3639: actions.EventHandlerImpl;
    act_5534025912102772_request_3630: actions.RequestAction;
    evh_5534025912102772_submit_3629: actions.EventHandlerImpl;
    evh_5534025912102772_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_3642: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_3641: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3626 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3626_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3625 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3626,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3625],
      }
    );
    const act_2248226175642056_closeComponent_3628 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3627 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_3628,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3627],
      }
    );
    const act_5534025912102772_register_3632 = new actions.RegisterAction(
      {
        actionArgs: this.act_5534025912102772_register_3632_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_success_3631 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_register_3632,
        event: "success",
        displayName: "register",
      }
    );
    const act_5534025912102772_notification_3634 = new actions.NotificationAction(
      {
        actionArgs: this.act_5534025912102772_notification_3634_getActionArgs,
        when: this.act_5534025912102772_notification_3634_getWhen,
        events: [],
      }
    );
    const evh_5534025912102772_success_3633 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_notification_3634,
        event: "success",
        displayName: "notification",
      }
    );
    const act_5534025912102772_notification_3636 = new actions.NotificationAction(
      {
        actionArgs: this.act_5534025912102772_notification_3636_getActionArgs,
        when: this.act_5534025912102772_notification_3636_getWhen,
        events: [],
      }
    );
    const evh_5534025912102772_success_3635 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_notification_3636,
        event: "success",
        displayName: "notification",
      }
    );
    const act_5534025912102772_closeModal_3638 = new actions.CloseModalAction(
      {
        actionArgs: this.act_5534025912102772_closeModal_3638_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_success_3637 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_closeModal_3638,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_5534025912102772_reloadSlickgrid_3640 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_5534025912102772_reloadSlickgrid_3640_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_success_3639 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_reloadSlickgrid_3640,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_5534025912102772_request_3630 = new actions.RequestAction(
      {
        actionArgs: this.act_5534025912102772_request_3630_getActionArgs,
        displayName: "submit",
        events: [evh_5534025912102772_success_3631, evh_5534025912102772_success_3633, evh_5534025912102772_success_3635, evh_5534025912102772_success_3637, evh_5534025912102772_success_3639],
      }
    );
    const evh_5534025912102772_submit_3629 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_request_3630,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_5534025912102772_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_submit_3629],
      }
    );
    const act_1419464017721962_closeModal_3642 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_3642_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3641 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_3642,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3641],
      }
    );
    return {
      act_7315092382398562_closeModal_3626,
      evh_7315092382398562_close_3625,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_3628,
      evh_2248226175642056_close_3627,
      evh_2248226175642056_close,
      act_5534025912102772_register_3632,
      evh_5534025912102772_success_3631,
      act_5534025912102772_notification_3634,
      evh_5534025912102772_success_3633,
      act_5534025912102772_notification_3636,
      evh_5534025912102772_success_3635,
      act_5534025912102772_closeModal_3638,
      evh_5534025912102772_success_3637,
      act_5534025912102772_reloadSlickgrid_3640,
      evh_5534025912102772_success_3639,
      act_5534025912102772_request_3630,
      evh_5534025912102772_submit_3629,
      evh_5534025912102772_submit,
      act_1419464017721962_closeModal_3642,
      evh_1419464017721962_clickPreventStop_3641,
      evh_1419464017721962_clickPreventStop,
      submit: act_5534025912102772_request_3630,
    }
  }
}

Vue.component("CompanyDataImportModal", CompanyDataImportModal);

</script>